import { css } from 'linaria';

export const modernMaterialsProduct = css`
  && {
    width: 204px;

    @media (--only-tablet) {
      width: 193px;

      &:nth-of-type(4) {
        width: 310px;
      }
    }

    @media (--only-mobile) {
      width: 217px;
    }
  }
`;

export const modernMaterialsProductPropertyWrapper = css`
  margin-bottom: 16px;
`;

export const modernMaterialsProductProperty = css`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const modernMaterialsImage = css`
  width: 144px;
  height: 144px;
  margin-bottom: 24px;
`;

export const modernMaterialsName = css`
  margin-bottom: 16px;
`;

export const modernMaterialsIconWrapper = css`
  display: flex;
  column-gap: 16px;
`;
